import React from 'react';
import { sgiLogger } from 'rt-sd-common';
import { getFunctionByKey, getConstByKey } from './SgiCommon';

export default class SgiComponent extends React.Component {
    /******************************** 生命周期 ********************************/
    /**************** 加载阶段 ****************/
	/**
	 * 生命周期-constructor
	 * 加载的时候调用一次，可以初始化state
	 * @param {*} props 
	 */
    constructor(props) {
        super(props);
        sgiLogger.debug_1(`>>>>SgiComponent [${props._name}][${props._key}] constructor`);
        // 状态集
        this.state = {
            _props: {},
            _class: [],
            _style: {},
        };
        // 数据集
        this.data = {
            functions: {}
        };
        // 事件集，外部为组件自定义的事件集
        this.funs = {};

        // 事件集解析
        if (this.props.moduleDesc && this.props.moduleDesc.funs) {
            let funs = this.props.moduleDesc.funs;
            try {
                let $funs = new Function("module", "objFct", funs);
                let { objFct } = this.props;
                funs = $funs(this, objFct);
                Object.assign(this.funs, funs);
                if (objFct) {
                    let oFuns = objFct.get("@funs");
                    if (!oFuns) {
                        oFuns = {};
                        objFct.set("@funs", oFuns);
                    }
                    Object.assign(oFuns, funs);
                }
            } catch (error) {
                sgiLogger.error("事件集解析出错，请检查组件自定义事件集书写是否正确！");
                sgiLogger.eventErr(error);
            }
        }
    }
	/**
	 * 生命周期-componentWillMount(加载前)
	 * 组件加载时只调用，以后组件更新不调用，整个生命周期只调用一次，此时可以修改state
	 * @deprecated 【不建议使用！react17将移除】
	 */
    componentWillMount() {
        sgiLogger.debug_1(`>>>>SgiComponent [${this.props._name}][${this.props._key}] componentWillMount`);
        this.__componentWillMount();
        // 自定义生命周期
        let cstmCycle = this.data.functions.componentWillMount;
        if (cstmCycle && typeof cstmCycle === "function") cstmCycle.call(this);
    }
	/**
	 * 生命周期-render(渲染)
	 * react最重要的步骤，创建虚拟dom，进行diff算法，更新dom树都在此进行
	 */
    render() {
        if (!this.loaded) {
            this._maker();
            this.loaded = true;
        }
        this._renderBeforeReturn();
        return this.__render();
    }
	/**
	 * 生命周期-componentDidMount(加载后)
	 * 组件渲染之后调用，只调用一次
	 */
    componentDidMount() {
        sgiLogger.debug_1(`>>>>SgiComponent [${this.props._name}][${this.props._key}] componentDidMount`);
        this.__componentDidMount();
        // 自定义生命周期
        let cstmCycle = this.data.functions.componentDidMount;
        if (cstmCycle && typeof cstmCycle === "function") cstmCycle.call(this);
    }

    /**************** 更新阶段 ****************/
	/**
	 * 生命周期-componentWillReceiveProps
	 * 组件加载时不调用，组件接受新的props时调用
	 * @deprecated 【不建议使用！react17将移除】
	 * @param {*} nextProps 
	 */
    componentWillReceiveProps(nextProps) {
        sgiLogger.debug_1(`>>>>SgiComponent [${this.props._name}][${this.props._key}] componentWillReceiveProps`);
        this.__componentWillReceiveProps(nextProps);
        // 自定义生命周期
        let cstmCycle = this.data.functions.componentWillReceiveProps;
        if (cstmCycle && typeof cstmCycle === "function") cstmCycle.call(this, nextProps);
    }
	/**
	 * 生命周期-getDerivedStateFromProps-【react16新增，constructor后render前也会执行】
	 * 组件每次被rerender的时候，包括在组件构建之后(虚拟dom之后，实际dom挂载之前)，每次获取新的props或state之后；
	 * 每次接收新的props之后都会返回一个对象作为新的state，返回null则说明不需要更新state；
	 * 配合componentDidUpdate，可以覆盖componentWillReceiveProps的所有用法
	 * @param {*} props 
	 * @param {*} state 
	 */
    getDerivedStateFromProps(props, state) {
        sgiLogger.debug_1(`>>>>SgiComponent [${props._name}][${props._key}] getDerivedStateFromProps`);
        let ret = this.__getDerivedStateFromProps(props, state);
        // 自定义生命周期
        // let cstmCycle = this.data.functions.getDerivedStateFromProps;
        // let cstmRet;
        // if (cstmCycle && typeof cstmCycle === "function") cstmRet = cstmCycle.call(this, props, state);
        // if (ret && cstmRet) {
        // 	ret = Object.assign(ret, cstmRet);
        // } else {
        // 	ret = ret || cstmRet;
        // }
        return ret;
    }
	/**
	 * 生命周期-shouldComponentUpdate
	 * 组件接收到新的props或者state时调用，
	 * return true就会更新dom（使用diff算法更新），
	 * return false能阻止更新（不调用render）
	 * @param {*} nextProps 
	 * @param {*} nextState 
	 */
    shouldComponentUpdate(nextProps, nextState) {
        sgiLogger.debug_1(`>>>>SgiComponent [${this.props._name}][${this.props._key}] shouldComponentUpdate`);
        let should = this.__shouldComponentUpdate(nextProps, nextState);
        // 自定义生命周期
        // let cstmCycle = this.data.functions.shouldComponentUpdate;
        // let cstmShould;
        // if (cstmCycle && typeof cstmCycle === "function") cstmShould = cstmCycle.call(this, nextProps, nextState);
        return should;
    }
	/**
	 * 生命周期-componentWillUpdate(更新前)
	 * 组件加载时不调用，只有在组件将要更新时才调用，此时可以修改state
	 * @deprecated 【不建议使用！react17将移除】
	 * @param {*} nextProps 
	 * @param {*} nextState 
	 */
    componentWillUpdate(nextProps, nextState) {
        sgiLogger.debug_1(`>>>>SgiComponent [${this.props._name}][${this.props._key}] componentWillUpdate`);
        this.__componentWillUpdate(nextProps, nextState);
        // 自定义生命周期
        let cstmCycle = this.data.functions.componentWillUpdate;
        if (cstmCycle && typeof cstmCycle === "function") cstmCycle.call(this, nextProps, nextState);
    }
	/**
	 * 生命周期-getSnapshotBeforeUpdate-【react16新增】
	 * 触发时间: update发生的时候，在render之后，在组件dom渲染之前；
	 * 返回一个值，作为componentDidUpdate的第三个参数；
	 * 配合componentDidUpdate, 可以覆盖componentWillUpdate的所有用法
	 * @param {*} prevProps 
	 * @param {*} prevState 
	 * ！！！注意：目前该生命周期接口会导致componentWillMount初始化生命周期失效，暂不使用！！！
	 */
    // getSnapshotBeforeUpdate(prevProps, prevState) {
    // 	sgiLogger.debug_1(`>>>>SgiComponent [${this.props._name}][${this.props._key}] getSnapshotBeforeUpdate`);
    // 	return this.__getSnapshotBeforeUpdate(prevProps, prevState);
    // }
	/**
	 * 生命周期-componentDidUpdate(更新后)
	 * 组件加载时不调用，组件更新完成后调用
	 */
    componentDidUpdate(prevProps, prevState, snapshot) {
        sgiLogger.debug_1(`>>>>SgiComponent [${this.props._name}][${this.props._key}] componentDidUpdate`);
        this.__componentDidUpdate(prevProps, prevState, snapshot);
        // 自定义生命周期
        let cstmCycle = this.data.functions.componentDidUpdate;
        if (cstmCycle && typeof cstmCycle === "function") cstmCycle.call(this, prevProps, prevState, snapshot);
    }

    /**************** 卸载阶段 ****************/
	/**
	 * 生命周期-componentWillUnmount(卸载前)
	 * 组件卸载前调用，只调用一次
	 */
    componentWillUnmount() {
        sgiLogger.debug_1(`>>>>SgiComponent [${this.props._name}][${this.props._key}] componentWillUnmount`);
        this.__componentWillUnmount();
        // 自定义生命周期
        let cstmCycle = this.data.functions.componentWillUnmount;
        if (cstmCycle && typeof cstmCycle === "function") cstmCycle.call(this);
    }

    /**************** 全阶段 ****************/
	/**
	 * 生命周期-componentDidCatch(错误处理)-【react16新增】
	 * 任何一处的javascript报错会触发
	 * @param {*} error 
	 * @param {*} info 
	 */
    componentDidCatch(error, info) {
        sgiLogger.debug_1(`>>>>SgiComponent [${this.props._name}][${this.props._key}] componentDidCatch`);
        this.__componentDidCatch(error, info);
        // 自定义生命周期
        let cstmCycle = this.data.functions.componentDidCatch;
        if (cstmCycle && typeof cstmCycle === "function") cstmCycle.call(this, error, info);
    }

    /******************************** 方法接管 ********************************/
    // 接管setState
    setState(...args) {
        sgiLogger.debug_1(`>>>>SgiComponent [${this.props._name}][${this.props._key}] setState call`);
        super.setState(...args);
    }

    /******************************** 子类实现 ********************************/
    // maker程序
    _maker() {
        sgiLogger.debug_1(`>>>>SgiComponent [${this.props._name}][${this.props._key}] _maker`);

        let { parentModule, moduleDesc, objFct, type } = this.props;
        let { _props, _class, _style } = this.state;
        let { functions } = this.data;

        // 转换基于描述
        if (!moduleDesc) return;

        let key = moduleDesc.key; //key
        if (key) _props.key = key;

        let cId = moduleDesc.cId; //id
        if (cId) _props.id = getConstByKey(this, cId);

        let ctlW = moduleDesc.ctlW; //控件宽度
        if (ctlW == 0 || ctlW == '0px') _style.width = undefined;
        else if (/^[0-9]+$/.test(ctlW)) _style.width = parseInt(ctlW);
        else _style.width = ctlW;

        let ctlH = moduleDesc.ctlH; //控件高度
        if (ctlH == 0 || ctlH == '0px') _style.height = undefined;
        else if (/^[0-9]+$/.test(ctlH)) _style.height = parseInt(ctlH);
        else _style.height = ctlH;

        let isBrdr = moduleDesc.isBrdr; //是否有边框
        if (isBrdr) {
            if (_class.indexOf("sgi-border") < 0) _class.push("sgi-border");
        } else if (_class.indexOf("sgi-border") > -1) {
            _class.splice(_class.indexOf("sgi-border"), 1);
        }

        _style.margin = moduleDesc.mgn;//控件外边距
        _style.padding = moduleDesc.pad;//控件内边距

        let isHdn = moduleDesc.isHdn; //是否隐藏
        if (isHdn) {
            _style.display = "none";
        } else {
            _style.display = undefined;
        }

        //公共属性里统一进行文本资源转换，各个控件可直接从ctnProps.te中取出结果，不再需要单独转换
        // if (moduleDesc.te || moduleDesc.teid) {//如果te和teid都不存在则不查找资源
        //     let te = Resource.getTRByPrm(moduleDesc).te; //显示名称
        //     if (te) ctnProps.te = te;
        // }
        let te = Resource.getTRByPrm(moduleDesc).te; //显示名称
        _props.te = te;

        // 初始加载中
        this.state.loading = moduleDesc.loading;

        // 自定义样式
        let cstmStyle = moduleDesc.cstmStyle;
        let $cstmStyle;
        if (cstmStyle) {
            try {
                $cstmStyle = new Function("module", "objFct", cstmStyle);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.cstmStyle = $cstmStyle;
        }

        // 属性透传，约定以"_"开始或以"antd_""antd-"开始的属性直接透传至props上
        for (const key in moduleDesc) {
            if (key.substr(0, 1) === "_" && moduleDesc[key] !== undefined) {
                _props[key.substring(1)] = moduleDesc[key];
            } else if ((key.substr(0, 5) === "antd_" || key.substr(0, 5) === "antd-") && moduleDesc[key] !== undefined) {
                _props[key.substring(5)] = moduleDesc[key];
            }
        }

        // 事件集--放入构建中，优先处理
        // let funs = moduleDesc.funs;
        // if (funs) {
        // 	var $funs;
        // 	try {
        // 		$funs = new Function("module", "objFct", funs);
        // 	} catch (error) {
        // 		sgiLogger.error("事件集解析出错，请检查组件自定义事件集");
        // 		sgiLogger.eventErr(error);
        // 	}
        // 	if ($funs) {
        // 		funs = $funs(this, objFct);
        // 		Object.assign(this.funs, funs);
        // 		if (objFct) {
        // 			let oFuns = objFct.get("@funs");
        // 			if (!oFuns) {
        // 				oFuns = {};
        // 				objFct.set("@funs", oFuns);
        // 			}
        // 			Object.assign(oFuns, funs);
        // 		}
        // 	}
        // }

        // 外部自定义生命周期
        let lifes = moduleDesc.lifes;
        if (lifes) {
            try {
                lifes = eval(`(${lifes})`);
                Object.assign(this.data.functions, lifes);
            } catch (error) {
                sgiLogger.error("生命周期解析出错，请检查组件自定义生命周期");
                sgiLogger.eventErr(error);
            }
        }
    }

	/**
     * 渲染前处理，包括自定义样式等
     * 初步设计为渲染前的通用处理，例如自定义样式等
     */
    _renderBeforeReturn() {
        const { parentModule, moduleDesc, objFct, type } = this.props;
        let { _props, _style } = this.state;

        // 自定义样式处理
        // const getCstmStyle = this.data.functions.cstmStyle;
        const getCstmStyle = getFunctionByKey(this, "cstmStyle");
        let cstmStyle = {};
        if (getCstmStyle) {
            try {
                cstmStyle = getCstmStyle(this, objFct) || {};
            } catch (error) {
                sgiLogger.error(error);
            }
        }
        Object.assign(_style, cstmStyle);
    }

    // 子组件实现
    __render() { return "__render未被实现" }
    __componentWillMount() { }
    __componentDidMount() { }
    __componentWillReceiveProps(nextProps) { }
    __getDerivedStateFromProps(props, state) { return state }
    __shouldComponentUpdate(nextProps, nextState) { return true }
    __componentWillUpdate(nextProps, nextState) { }
    __getSnapshotBeforeUpdate(prevProps, prevState) { return null }
    __componentDidUpdate() { }
    __componentWillUnmount() { }
    __componentDidCatch(error, info) {
        // sgiLogger.error(error);
        // sgiLogger.error(info.componentStack);
    }

    /******************************** 基本方法 ********************************/
    reload = () => {
        this.loaded = false;

        // 重置数据（引用，否则react16不更新组件）--并没有解决实际问题
        // this.constructor(this.props);

        this.setState({});
    }
    refresh = () => {
        this.loaded = false;
        this.setState({});
    }
    setLoading(loading) {
        this.setState({ loading });
    }

    // 通用动态方法
    setProps(key, value, type) {
        type = type || "_props";
        let p = this.state[type];
        if (p && key) {
            p[key] = value;
            this.setState({ [type]: p });
        }
        return p;
    }
    addClass(value, type) {
        type = type || "_class";
        let c = this.state[type];
        if (c && value && c.indexOf(value) < 0) {
            c.push(value);
            this.setState({ [type]: c });
        }
        return c;
    }
    removeClass(value, type) {
        type = type || "_class";
        let c = this.state[type];
        if (c && value && c.indexOf(value) > -1) {
            c.splice(c.indexOf(value), 1);
            this.setState({ [type]: c });
        }
        return c;
    }
    setStyle(key, value, type) {
        type = type || "_style";
        let s = this.state[type];
        if (s && key) {
            s[key] = value;
            this.setState({ [type]: s });
        }
        return s;
    }
}


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/sgiBaseComp/SgiComponent.js